module.exports = __webpack_public_path__ + "static/media/Banner_UniqueEvent_v1_1.3163cbde.png";